import { render } from "./GroupAssignDialog.vue?vue&type=template&id=4f2d94ef&scoped=true"
import script from "./GroupAssignDialog.vue?vue&type=script&lang=js"
export * from "./GroupAssignDialog.vue?vue&type=script&lang=js"

import "./GroupAssignDialog.vue?vue&type=style&index=0&id=4f2d94ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2d94ef"]])

export default __exports__